// extracted by mini-css-extract-plugin
export var fadeIn = "_ks-1";
export var modalContent = "_ks-3";
export var overlay = "_ks-0";
export var popoverContent = "_ks-2";
export var results = "_ks-5";
export var searchInputWrapper = "_ks-4";